import { Button, Icon } from '@pwc/pwc-deals-ui';
import { FC } from 'react';

type Props = {
  isPanelOpened: boolean;
  onClose: () => void;
};

const PreviewPanelHeader: FC<Props> = ({ isPanelOpened, onClose }) => {
  return (
    <div className={`comment-panel-header${isPanelOpened ? ' opened' : ''}`}>
      {isPanelOpened && (
        <div
          className="comment-panel-header__label"
          role="heading"
          aria-level={1}
          data-testid="comment-panel-header__label"
        >
          Report Preview
        </div>
      )}

      <Button
        className="panel-button"
        aria-label="preview icon"
        data-testid="preview-button"
        onClick={onClose}
        icon={undefined}
        iconClasses={undefined}
      >
        <Icon name="close" className="fill icon-orange" width="18" />
      </Button>
    </div>
  );
};

export default PreviewPanelHeader;
